/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bookmark': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M231 84.1v842.2c0 11.9 6.7 14.8 14.9 6.3l239.6-246.1c8.2-8.4 21.5-8.4 29.8 0l239.6 246.1c8.2 8.4 14.9 5.6 14.9-6.3V84.1c0-11.9-9.5-21.6-21-21.6H252c-11.6 0-21 9.7-21 21.6z"/>'
  }
})
